import {
  pipelineService,
  type TestimonialUniqueField,
  type TestimonialUniques,
  type TestimonialUniquesFilters,
} from "@/api/pipeline.service";
import { useQuery } from "./useApi";

type TestimonialUniquesResult<Field extends TestimonialUniqueField> = TestimonialUniquesFilters & {
  values: TestimonialUniques[Field][];
};

export function useTestimonialUniques<Field extends TestimonialUniqueField>(
  field: Field,
  filters: TestimonialUniquesFilters,
  enabled: boolean,
) {
  const { data, error } = useQuery<TestimonialUniquesResult<Field>>(
    () =>
      enabled
        ? pipelineService
            .getTestimonialUniques(field, filters)
            .then(result => ({ ...filters, ...result }))
        : Promise.resolve({ ...filters, values: [] }),
    [enabled, field, filters.editionId, filters.rankingEntityId],
  );
  const current =
    data !== null &&
    data.editionId === filters.editionId &&
    data.rankingEntityId === filters.rankingEntityId;
  return { data: current ? data : null, error };
}
